import { InjectionToken } from '@angular/core';
import { MarkHandlerInterface } from '@core/content-handlers/mark-handler.interface';

export const MARK_HANDLERS_INJECTION_TOKEN =
  new InjectionToken<MarkHandlerInterface[]>('MARK_HANDLERS_INJECTION_TOKEN');
